import React from 'react';
import {ResultLabelProps, Status} from '../../../interfaces/unsplash';

const ResultLabel = (props: ResultLabelProps) => {

    const { keyword, status, resultCount } = props;

    if (keyword !== "") {
        if (status === Status.finished) {

            if (!resultCount) {
                return null;
            }

            return (
                <h2 className="result-label">Showing results for ‘{keyword}’ via Unsplash</h2>
            )
        }
        else if (status === Status.searching) {
            return (
                <h2 className="result-label">Searching for ‘{keyword}’ via Unsplash</h2>
            )
        }
    }

    return (
        <h2 className="result-label">Showing results for ‘Editorial’ via Unsplash</h2>
    )

};

export default ResultLabel;